import bem from "easy-bem";
import React from "react";
import "./Spacer.css";

const cn = bem("spacer");

type SpacerProps = {
  children: React.ReactNode;
  withSeparator?: boolean;
  mode?: "center" | "justify";
  rightmost?: boolean;
};

const Spacer: React.FC<SpacerProps> = ({
  children,
  withSeparator = false,
  mode = "center",
  rightmost = false,
}) => {
  const childrenArray = React.Children.toArray(children).filter(Boolean);

  return (
    <div
      className={cn({
        withSeparator:
          withSeparator &&
          (rightmost ? childrenArray.length > 2 : childrenArray.length > 1),
        [mode]: true,
        rightmost,
      })}
    >
      {childrenArray.filter(Boolean).map((child, index, array) => (
        <div
          key={index}
          className={cn("child", {
            rightmost: rightmost && index === array.length - 1,
          })}
        >
          {child}
        </div>
      ))}
    </div>
  );
};

export default Spacer;
